import { z } from "zod";

// GET …/user-rights/check: maps each requested Shiro right to whether the user has it
export const coreUserRightsCheckSchema = z.object({
    data: z.object({
        userRights: z.record(z.string(), z.boolean())
    })
});
